import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import banner1 from "../assets/home/banner1.png";
import banner2 from "../assets/home/banner2.png";
import banner3 from "../assets/home/banner3.png";
import banner4 from "../assets/home/banner4.png";

const IMAGES = [banner1, banner2, banner3, banner4];

export default function HeroBanner({
  title = "Fresh, Organic & Local",
  subtitle = "Delivered straight from Manchester to your doorstep.",
}) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  // Auto-slide every 5 seconds, but not while the visitor is hovering or has focus inside
  useEffect(() => {
    if (paused) return undefined;
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % IMAGES.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [paused]);

  return (
    <div
      className="hero-banner"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      {/* key makes the image remount, so the fade-in plays on every slide */}
      <img key={index} src={IMAGES[index]} alt="Aquaviva Foods products" className="hero-image" />

      <div className="hero-text">
        <h1>{title}</h1>
        <p>{subtitle}</p>
        <Link to="/products" className="ui-btn ui-btn--primary hero-cta">
          Shop now
        </Link>
      </div>

      <div className="hero-dots">
        {IMAGES.map((_, i) => (
          <button
            key={i}
            type="button"
            className={`dot ${i === index ? "active" : ""}`}
            aria-label={`Show banner ${i + 1}`}
            aria-current={i === index ? "true" : undefined}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </div>
  );
}